var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.container.items.length > 1
    ? _c(
        _vm.is,
        { tag: "component" },
        _vm._l(_vm.container.items, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "indicator-item",
              class: {
                "indicator-item_active": item === _vm.container.activeItem
              }
            },
            [
              _c("button", {
                staticClass: "indicator-button",
                on: {
                  click: function($event) {
                    return _vm.updateActiveItem(item)
                  }
                }
              })
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-340440da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340440da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/CarouselIndicators.vue
// module id = null
// module chunks = 